const addLayerColumn = (state, {layerId, column}) => {
  const index = state.layers.findIndex(x => x.layerId === layerId)
  if (index > -1) {
    state.layers[index].draft.select.push(column)
    state.layers[index].draft.dirty = true
  }
}
const clearMapMarkers = (state) => {
  state.mapMarkers = []
}
const pushMapMarker = (state, marker) => {
  state.mapMarkers.push(marker)
}
const removeLayerColumn = (state, {layerId, column}) => {
  const index = state.layers.findIndex(x => x.layerId === layerId)
  if (index > -1) {
    state.layers[index].draft.select = state.layers[index].draft.select.filter(x => x.id !== column.id)
    state.layers[index].draft.dirty = true
  }
}
const setActiveCoords = (state, coords) => {
  state.activeCoords = coords
}
const setActiveLayer = (state, layerId) => {
  state.activeLayerId = layerId
}
const setBounds = (state, bounds) => {
  state.bounds = bounds
}
const setIsDirtyLayer = (state, layerId) => {

}
const setMarkerLayer = (state, layer) => {
  state.targetMarkerLayer = layer
}
const setMarkerPopup = (state, { popup, index = 0, toggle = false }) => {
  state.mapMarkers[index].setPopup(popup)
  if (toggle) state.mapMarkers[index].togglePopup()
}
const setZoom  = (state, zoom) => {
  state.zoom = zoom
}

export default {
  addLayerColumn,
  clearMapMarkers,
  pushMapMarker,
  removeLayerColumn,
  setActiveCoords,
  setActiveLayer,
  setBounds,
  setIsDirtyLayer,
  setMarkerLayer,
  setMarkerPopup,
  setZoom,
}
